// Simple client-side cache for customer data
// Uses localStorage to avoid network requests for recently scanned customers

const CACHE_PREFIX = 'customer_cache_';
const CACHE_EXPIRY = 1000 * 60 * 5; // 5 minutes

interface CachedItem {
  data: any;
  timestamp: number;
}

export function cacheCustomer(key: string, data: any): void {
  if (typeof window === 'undefined') return;
  
  try {
    const item: CachedItem = {
      data,
      timestamp: Date.now(),
    };
    localStorage.setItem(CACHE_PREFIX + key, JSON.stringify(item));
  } catch (e) {
    console.warn('Failed to cache customer data:', e);
  }
}

export function getCachedCustomer(key: string): any | null {
  if (typeof window === 'undefined') return null;

  try {
    const stored = localStorage.getItem(CACHE_PREFIX + key);
    if (!stored) return null;

    const item: CachedItem = JSON.parse(stored);
    
    // Check expiry
    if (Date.now() - item.timestamp > CACHE_EXPIRY) {
      localStorage.removeItem(CACHE_PREFIX + key);
      return null;
    }

    return item.data;
  } catch (e) {
    console.warn('Failed to retrieve cached customer data:', e);
    return null;
  }
}
